import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React from 'react';
import { useForm } from 'react-hook-form';
import { fetchAndSetEvent } from '../../../../../../reduxToolkit/slices/commonSlice';
import { useDispatch } from '../../../../../../reduxToolkit/typedRedux';

interface SearchProps {
  onChange?: (query: string) => void;
  fetchFromEvent?: boolean;
}

const Search = (props: SearchProps) => {
  const { onChange, fetchFromEvent = true } = props;

  const { register, handleSubmit, watch, setValue, getValues } = useForm();
  const { t } = useTranslation('common');

  const {
    query: { slug },
  } = useRouter();

  const dispatch = useDispatch();

  function clearSearch() {
    setValue('searchPhrase', '');
    submit(getValues());
  }

  function submit(val: Record<string, string>) {
    if (!slug) return;
    val.slug = slug.toString();
    fetchFromEvent && dispatch(fetchAndSetEvent(val));
    onChange && onChange(val.searchPhrase);
  }

  return (
    <>
      <form className="relative" onSubmit={handleSubmit(submit)}>
        <input
          {...register('searchPhrase')}
          className="transition-all focus:sm:w-[160px] rounded w-full @sm:w-24 self-center p-2 bg-vystem-gray pl-6 outline-none text-gray-800 border-gray-500 border"
          placeholder={t('common:to-search')}
          type="text"
        />
        <div>
          <FontAwesomeIcon icon={faSearch} className="absolute text-black" style={{ top: '12px', left: '8px' }} />
          {watch('searchPhrase') && (
            <FontAwesomeIcon icon={faTimes} onClick={clearSearch} className="absolute text-black cursor-pointer" style={{ top: '6px', right: '8px' }} />
          )}
        </div>
      </form>
    </>
  );
};

export default Search;
